module.exports = "Powered by Front Communications AS\n"